import { render, staticRenderFns } from "./PermitList.vue?vue&type=template&id=087c7d4d&scoped=true"
import script from "./PermitList.vue?vue&type=script&lang=js"
export * from "./PermitList.vue?vue&type=script&lang=js"
import style0 from "./PermitList.vue?vue&type=style&index=0&id=087c7d4d&prod&lang=css"
import style1 from "./PermitList.vue?vue&type=style&index=1&id=087c7d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c7d4d",
  null
  
)

export default component.exports